<header class="p-1">
  <div
    class="relative rounded-xl border border-slate-200 bg-white p-2 sm:p-3 shadow-sm"
  >
    <!-- Decoración sutil de fondo (más pequeña) -->
    <div
      class="pointer-events-none absolute -right-5 -top-5 h-16 w-16 rounded-full bg-sky-50 blur-xl"
    ></div>

    <div class="relative z-10 flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
      <!-- Lado Izquierdo: Título y Contexto -->
      <div class="flex items-center gap-3 min-w-0">
        @if (icon() != undefined) {
          <span
            class="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg border border-sky-100 bg-sky-50 text-sky-600"
          >
            <i [class]="icon()" class="text-sm"></i>
          </span>
        }

        <div class="min-w-0">
          <div class="flex items-center gap-2">
            <h3 class="truncate text-lg font-bold tracking-tight text-slate-900 sm:text-xl">
              {{ title() }}
            </h3>

            @if (showBackButton() == true) {
              <button
                (click)="goBack()"
                class="flex items-center gap-1 text-xs font-medium text-slate-500 hover:text-sky-600 transition-colors"
              >
                <i class="bi bi-arrow-left"></i>
                <span class="hidden sm:inline">Volver</span>
              </button>
            }
          </div>

          <!-- Subtítulo en una sola línea y pequeño -->
          <p class="truncate text-[11px] font-medium text-slate-500 sm:text-xs">
            {{ subtitle() }}
            @if (mostrarAlertaVencimiento()) {
              <span
                class="ml-2 inline-flex items-center gap-1 rounded-md bg-red-50 px-1.5 py-0.5 text-[10px] font-bold text-red-600 border border-red-100"
              >
                <i class="bi bi-exclamation-triangle-fill"></i>
                {{ estadoAlertaVencimiento() }}
              </span>
            }
          </p>
        </div>
      </div>

      <!-- Lado Derecho: Controles -->
      <div class="flex items-center gap-2">
        <!-- Info del usuario logueado (Desktop MD+) -->
        @if (emailUsuario()) {
          <div
            class="hidden items-center gap-2.5 rounded-lg border border-slate-200 bg-slate-50/80 px-3 py-1.5 md:flex"
            [title]="emailUsuario() ?? ''"
          >
            <i class="bi bi-person-circle text-base text-sky-600"></i>
            <div class="flex flex-col min-w-0 max-w-40">
              <span class="truncate text-xs font-semibold text-slate-800">
                {{ nombreUsuario() }}
              </span>
              <span class="truncate text-[10px] text-slate-500">
                {{ emailUsuario() }}
              </span>
            </div>
          </div>
        }

        <!-- Vista Desktop (MD+) -->
        <div class="hidden items-center gap-2 md:flex">
          <div class="h-8 w-px bg-slate-200 mx-1"></div>
          <!-- Separador -->
          <app-selector-impresora />
          <app-selector-sucursal />
        </div>

        <!-- Vista Mobile (Dropdown compacto) -->
        <div class="flex w-full md:hidden">
          <button
            type="button"
            class="flex w-full items-center justify-between rounded-lg border border-slate-200 bg-slate-50 px-3 py-1.5 text-xs font-semibold text-slate-600"
            (click)="toggleControlesMoviles()"
          >
            <span class="flex items-center gap-2">
              <i class="bi bi-gear-fill text-sky-600"></i>
              Configuración
            </span>
            <i
              class="bi"
              [class.bi-chevron-down]="!mostrarControlesMoviles()"
              [class.bi-chevron-up]="mostrarControlesMoviles()"
            ></i>
          </button>
        </div>
      </div>
    </div>

    <!-- Panel desplegable móvil -->
    @if (mostrarControlesMoviles()) {
      <div class="mt-2 grid gap-2 rounded-lg border border-slate-100 bg-slate-50/50 p-2 md:hidden">
        @if (emailUsuario()) {
          <div
            class="flex items-center gap-2.5 rounded-lg border border-slate-200 bg-white px-3 py-1.5"
            [title]="emailUsuario() ?? ''"
          >
            <i class="bi bi-person-circle text-base text-sky-600"></i>
            <div class="flex flex-col min-w-0">
              <span class="truncate text-xs font-semibold text-slate-800">
                {{ nombreUsuario() }}
              </span>
              <span class="truncate text-[10px] text-slate-500">
                {{ emailUsuario() }}
              </span>
            </div>
          </div>
        }
        <app-selector-impresora />
        <app-selector-sucursal />
      </div>
    }
  </div>
</header>
